import React from "react";
import {
  curatedBlockImg1,
  curatedBlockImg2,
  curatedBlockImg3,
  curatedBlockImg4,
  RightArrow,
} from "../../../assets";
import { useNavigate } from "react-router-dom";

const CuratedBlock = ({ homeData }) => {
  const navigate = useNavigate();
  return (
    <div className="p-4 pb-16 bg-[#FCF5F0]">
      <div className="text-primary text-3xl lg:text-4xl text-center tracking-[2.65px] my-2 mt-10 cormorant-medium">
        {homeData?.curatedCollection?.title}
      </div>
      <div className="text-text_dark_2 text-lg lg:text-xl text-center my-2 mb-10 lato-regular">
        {homeData?.curatedCollection?.description}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group">
          <div className="relative aspect-[11/10]">
            <img
              src={homeData?.curatedCollection?.slider[0]?.image}
              alt="bangale-1"
              className="w-full h-auto pt-6 px-6"
            />
            {/* <div className="absolute bottom-3 left-0 right-0 flex items-center justify-center mb-2">
              <div className="bg-white bg-opacity-40 backdrop-blur-md rounded-full px-4 py-[3px]">
                <p className="text-white text-[8px] lg:text-base lato-regular ">
                  {homeData?.curatedCollection?.slider[0]?.count}+ Designs
                </p>
              </div>
            </div> */}
          </div>
          <div className="pb-4 pt-2 flex flex-row flex-grow justify-center items-center mt-2">
            <button
              onClick={() =>
                navigate(homeData?.curatedCollection?.slider[0]?.redirects)
              }
              className="lato-regular text-[#1C1919] py-2 pl-2 pr-2 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[10px] lg:pl-6 lg:pr-6 lg:text-[13px] xl:text-[16px]  border-[1px] border-[#1C1919] rounded-full font-medium transition-all duration-500 lg:group-hover:pr-16 lg:group-hover:bg-primary lg:group-hover:text-[#FCF5F0] "
            >
              {homeData?.curatedCollection?.slider[0]?.name}
            </button>
            <img
              src={RightArrow}
              className="p-1 h-[32px] w-[32px] sm:h-[41px] sm:w-[41px] md:h-[32px] md:w-[32px] lg:h-[38px] lg:w-[38px] xl:h-[41px] xl:w-[41px] border-[1px] border-[#1C1919] rounded-full text-sm font-medium transition-all duration-500 lg:group-hover:translate-x-[-40px] lg:group-hover:bg-[#FCF5F0] lg:group-hover:text-primary lg:group-hover:scale-90"
            />
          </div>
        </div>
        <div className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group">
          <div className="relative aspect-[11/10]">
            <img
              src={homeData?.curatedCollection?.slider[1]?.image}
              alt="bangale-1"
              className="w-full h-auto pt-6 px-6"
            />
            {/* <div className="absolute bottom-3 left-0 right-0 flex items-center justify-center mb-2">
              <div className="bg-white bg-opacity-40 backdrop-blur-md rounded-full px-4 py-[3px]">
                <p className="text-white text-[8px] lg:text-base lato-regular ">
                  {homeData?.curatedCollection?.slider[1]?.count}+ Designs
                </p>
              </div>
            </div> */}
          </div>
          <div className=" pb-4 pt-2 flex flex-row flex-grow justify-center items-center mt-2">
            <button
              onClick={() =>
                navigate(homeData?.curatedCollection?.slider[1]?.redirects)
              }
              className=" lato-regular text-[#1C1919] py-2 pl-2 pr-2 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[10px] lg:pl-6 lg:pr-6 lg:text-[13px] xl:text-[16px]  border-[1px] border-[#1C1919] rounded-full font-medium transition-all duration-500 lg:group-hover:pr-16 lg:group-hover:bg-primary lg:group-hover:text-[#FCF5F0]"
            >
              {homeData?.curatedCollection?.slider[1]?.name}
            </button>
            <img
              src={RightArrow}
              className="p-1 h-[32px] w-[32px] sm:h-[41px] sm:w-[41px] md:h-[32px] md:w-[32px] lg:h-[38px] lg:w-[38px] xl:h-[41px] xl:w-[41px] border-[1px] border-[#1C1919] rounded-full text-sm font-medium transition-all duration-500 lg:group-hover:translate-x-[-40px] lg:group-hover:bg-[#FCF5F0] lg:group-hover:text-primary lg:group-hover:scale-90"
            />
          </div>
        </div>
        <div className="bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl group">
          <div className="relative aspect-[11/10]">
            <img
              src={homeData?.curatedCollection?.slider[2]?.image}
              alt="bangale-1"
              className="w-full h-auto pt-6 px-6"
            />
            {/* <div className="absolute bottom-3 left-0 right-0 flex items-center justify-center mb-2">
              <div className="bg-white bg-opacity-40 backdrop-blur-md rounded-full px-4 py-[3px]">
                <p className="text-white text-[8px] lg:text-base lato-regular ">
                  {homeData?.curatedCollection?.slider[2]?.count}+ Designs
                </p>
              </div>
            </div> */}
          </div>
          <div className=" pb-4 pt-2 flex flex-row flex-grow justify-center items-center mt-2">
            <button
              onClick={() =>
                navigate(homeData?.curatedCollection?.slider[2]?.redirects)
              }
              className=" lato-regular text-[#1C1919] py-2 pl-2 pr-2 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[10px] lg:pl-6 lg:pr-6 lg:text-[13px] xl:text-[16px]  border-[1px] border-[#1C1919] rounded-full font-medium transition-all duration-500 lg:group-hover:pr-16 lg:group-hover:bg-primary lg:group-hover:text-[#FCF5F0]"
            >
              {homeData?.curatedCollection?.slider[2]?.name}
            </button>
            <img
              src={RightArrow}
              className="p-1 h-[32px] w-[32px] sm:h-[41px] sm:w-[41px] md:h-[32px] md:w-[32px] lg:h-[38px] lg:w-[38px] xl:h-[41px] xl:w-[41px] border-[1px] border-[#1C1919] rounded-full text-sm font-medium transition-all duration-500 lg:group-hover:translate-x-[-40px] lg:group-hover:bg-[#FCF5F0] lg:group-hover:text-primary lg:group-hover:scale-90"
            />
          </div>
        </div>
        <div className="bg-gradient-to-tr from-[white] via-white to-[#FCF5F0] rounded-xl  group">
          <div className="relative aspect-[11/10]">
            <img
              src={homeData?.curatedCollection?.slider[3]?.image}
              alt="bangale-1"
              className="w-full h-auto pt-6 px-6"
            />
            {/* <div className="absolute bottom-3 left-0 right-0 flex items-center justify-center mb-2">
              <div className="bg-white bg-opacity-40 backdrop-blur-md rounded-full px-4 py-[3px]">
                <p className="text-white text-[8px] lg:text-base lato-regular ">
                  {homeData?.curatedCollection?.slider[3]?.count}+ Designs
                </p>
              </div>
            </div> */}
          </div>
          <div className="pb-4 pt-2 flex flex-row flex-grow justify-center items-center mt-2">
            <button
              onClick={() =>
                navigate(homeData?.curatedCollection?.slider[3]?.redirects)
              }
              className=" lato-regular text-[#1C1919] py-2 pl-2 pr-2 text-[10px] sm:pl-8 sm:pr-8 sm:text-[16px] md:pl-4 md:pr-4 md:text-[10px] lg:pl-6 lg:pr-6 lg:text-[13px] xl:text-[16px]  border-[1px] border-[#1C1919] rounded-full font-medium transition-all duration-500 lg:group-hover:pr-16 lg:group-hover:bg-primary lg:group-hover:text-[#FCF5F0]"
            >
              {homeData?.curatedCollection?.slider[3]?.name}
            </button>
            <img
              src={RightArrow}
              className="p-1 h-[32px] w-[32px] sm:h-[41px] sm:w-[41px] md:h-[32px] md:w-[32px] lg:h-[38px] lg:w-[38px] xl:h-[41px] xl:w-[41px] border-[1px] border-[#1C1919] rounded-full text-sm font-medium transition-all duration-500 lg:group-hover:translate-x-[-40px] lg:group-hover:bg-[#FCF5F0] lg:group-hover:text-primary lg:group-hover:scale-90"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuratedBlock;
